<vitamui-dialog-header
  [stepper]="stepper"
  [subhead]="'ARCHIVE_UNIT.DIALOGS.CANCEL.TITLE' | translate"
  [title]="[
    'SUBROGATION.HOME.RESULTS_TABLE.MODAL.TITLE' | translate,
    'SUBROGATION.HOME.RESULTS_TABLE.MODAL.WAITING_ACCEPTATION' | translate,
  ]"
></vitamui-dialog-header>

<vitamui-stepper #stepper [selectedIndex]="stepIndex()" (selectionChange)="stepIndex.set($event.selectedIndex)">
  <cdk-step>
    <mat-dialog-content>
      <div>
        <div class="d-flex">
          <vitamui-input [formField]="form.emailFirstPart" [placeholder]="'SUBROGATION.HOME.RESULTS_TABLE.MODAL.MAIL' | translate">
          </vitamui-input>

          <h4 class="mx-2 mt-1 light">&#64;</h4>

          <vitamui-select [formField]="form.domain" [options]="domains" [multiple]="false" [enableSearch]="false"></vitamui-select>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button class="btn primary" appStepperNext (click)="askForSubrogation()" [disabled]="form().invalid()">
        {{ 'SUBROGATION.HOME.RESULTS_TABLE.MODAL.BUTTON' | translate }}
      </button>
      <button class="btn cancel link" (click)="onCancel()">{{ 'COMMON.UNDO' | translate }}</button>
    </mat-dialog-actions>
  </cdk-step>

  <cdk-step>
    <mat-dialog-content>
      @if (user?.firstname && user?.lastname) {
        <div class="text normal">
          {{ 'SUBROGATION.HOME.RESULTS_TABLE.MODAL.ASK_SUBROGATION' | translate }} {{ user?.firstname }} {{ user?.lastname }}
        </div>
      }

      @if (!user?.firstname || !user?.lastname) {
        <div class="text normal">{{ 'SUBROGATION.HOME.RESULTS_TABLE.MODAL.ASK_SUBROGATION' | translate }} {{ user?.email }}</div>
      }

      <div class="d-flex justify-content-center align-items-center my-5">
        @if (pending) {
          <mat-spinner class="vitamui-spinner large"></mat-spinner>
        }
      </div>
    </mat-dialog-content>

    <mat-dialog-actions>
      <button type="button" class="btn cancel link" (click)="cancelSubrogation()">{{ 'COMMON.UNDO' | translate }}</button>
    </mat-dialog-actions>
  </cdk-step>
</vitamui-stepper>
